export default __webpack_public_path__ + "static/06-rfq-fabric-9b25eb8fe6b69f0a7aa646570950c113.png";